import { ModalContent, ModalHeader, ModalCloseButton, ModalBody, Box, Button } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormikInput } from 'components/Formik';
import { useConnectEveree } from 'hooks/integrations/everee/useConnectEveree';
import { useSyncEvereeWorkers } from 'hooks/integrations/everee/useSyncEvereeWorkers';

import { connectFormValidationSchema, initialConnectFormData } from './schema';

interface IConnectFormProps {
  onClose: () => void;
}

const ConnectForm: React.FC<IConnectFormProps> = ({ onClose }) => {
  const { t } = useTranslation(['common', 'integrations']);

  const { mutateAsync, isLoading } = useConnectEveree();
  const { mutate: syncWorkersMutate } = useSyncEvereeWorkers();

  const handleFormSubmit = (values: typeof initialConnectFormData) => {
    mutateAsync(values).then(() => {
      syncWorkersMutate();
      onClose();
    });
  };

  return (
    <ModalContent>
      <ModalHeader>Connect to Everee</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Formik
          enableReinitialize
          initialValues={initialConnectFormData}
          validationSchema={connectFormValidationSchema}
          onSubmit={handleFormSubmit}
        >
          {() => (
            <Form noValidate>
              <FormikInput
                type="text"
                name="everee_tenant_id"
                label="Tenant ID"
                formControlProps={{ isRequired: true }}
              />
              <FormikInput
                type="password"
                name="everee_api_key"
                label="API Token"
                formControlProps={{ isRequired: true }}
              />

              <Box textAlign="right">
                <Button bg="gray.600" _hover={{ bg: 'gray.700' }} _active={{ bg: 'gray.700' }} onClick={onClose}>
                  {t('common:close')}
                </Button>
                <Button type="submit" colorScheme="secondary" isLoading={isLoading} ml="5">
                  {t('integrations:connect')}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </ModalContent>
  );
};

export default ConnectForm;
